import axios from '../axios.jsx';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';



const URI = 'sat/';
const URI2 = 'fuente/';

const CompviewBlog = () => {
  const [fechaIngreso, setFechaIngreso] = useState('');
  const [semanaepi, setsemanaepi] = useState('');
  const [municipio, setmunicipio] = useState('');
  const [fuentes, setfuentes2] = useState('');
  const [codigoSat, setCodigoSat] = useState('');
  const [eventos, seteventos] = useState('');
  const [eventos2, seteventos2] = useState([]);
  const [titulo, settitulo] = useState('');
  const [resumen, setresumen] = useState('');
  const [fuente, setfuente] = useState([]);
  const [gestor, setgestor] = useState('');
  const [mostrarEvaluacion, setMostrarEvaluacion] = useState(false);
  const [evaluacion, setEvaluacion] = useState('');
  const [nivel, setNivel] = useState('');
  const [respuesta, setRespuesta] = useState('');
  const navigate = useNavigate();
  const [Activa_SAR, setActivaSAR] = useState("");  // o "NO" por defecto
  const [Activa_ERI, setActivaERI] = useState("");



  const { id } = useParams()


  useEffect(() => {
 
    getBlogById();
    geteventoById();

  }, []);



  const getBlogById = async () => {
      const res = await axios.get(URI + id)
      const iso = res.data.Fecha_identificacion;
  const dateOnly = iso ? iso.split('T')[0] : '';
  setFechaIngreso(dateOnly);
      setsemanaepi(res.data.Semana_epi)
      settitulo(res.data.Titulo)
      setresumen(res.data.Resumen)
      setCodigoSat(res.data.Codigo)
      setmunicipio(res.data.Municipio)
      setfuentes2(res.data.Fuente)
      seteventos(res.data.Evento)
      setEvaluacion(res.data.Puntaje)
      setNivel(res.data.Nivel_Riesgo)
      setRespuesta(res.data.Respuesta)
      setgestor(res.data.Gestor)
      setActivaSAR(res.data.Activa_SAR)
      setActivaERI(res.data.Activa_ERI)
      try {
            const res = await axios.get(URI2);
            setfuente(res.data);
          } catch (error) {
            console.error('Error al obtener fuentes:', error);
          }
    }


  const geteventoById = async () => {
    try {
      const res = await axios.get('/eventos');
      seteventos2(res.data);
    } catch (error) {
      console.error('Error al obtener eventos:', error);
    }
  };



  return (
    <div className="container">
      <h2 className="text-center mb-5 mt-3">FORMULARIO SISTEMA DE ALERTA TEMPRANA</h2>
        <div className="row">
          <div className="col-md-6">
            {/* Campos lado izquierdo */}
            {/* ...[campos existentes]... */}
            <label className="mb-1">Codigo SAT</label>
            <input type="text" className="form-control mb-2" value={codigoSat} readOnly />
            <label className="mb-1">Fecha de ingreso</label>
<input
  type="date"
  className="form-control mb-2"
  value={fechaIngreso}
  readOnly
/>

            <label className="mb-1">Semana epidemiologica</label>
            <input type="text" className="form-control mb-2" value={semanaepi} readOnly/>
            <label className="mb-1">Gestor SAT</label>
            <input type="text" className="form-control mb-2" value={gestor} readOnly />
            <label className="mb-1">Municipio</label>
              <input
                className="form-control mb-2"
                value={municipio}
                readOnly
              />
             
            <label className="mb-1">Fuente</label>
            <input className="form-control mb-2" value={fuentes} readOnly/>
            <label className="mb-1">Evento</label>
            <input className="form-control mb-2" value={eventos} readOnly/>
             
          </div>

          <div className="col-md-6">
            {/* Campos lado derecho */}
            <label>Título</label>
            <textarea className="form-control mb-2" value={titulo} readOnly/>
            <label>Resumen</label> 
            <textarea
            className="form-control mb-2"
            style={{ height: '200px', resize: 'vertical' }}
            value={resumen}
            readOnly 
            />

            <div className="row g-3">
              <div className="col-md-6">
                <label>Evaluación del riesgo</label>
                <input className="form-control" value={evaluacion} readOnly />
              </div>
              <div className="col-md-6">
                <label>Nivel del riesgo</label>
                <input type="text" className="form-control" value={nivel} readOnly />
              </div>
            </div>
            <label className="mt-2">Respuesta</label>
            <input type="text" className="form-control mb-3" value={respuesta} readOnly />

            <div className="row g-3">
              <div className="col-md-6">
                <label>Activa SARS</label>
                <input className="form-control" value={Activa_SAR} readOnly /> 
                </div>
              <div className="col-md-6">
                <label>Despliegue ERI</label>
                <input className="form-control" value={Activa_ERI} readOnly /> 
                </div></div>
          
        </div>
          
          </div>


        <div className="form-group text-center mt-4">
           <button
      type="button"
      className="btn btn-success"
      onClick={() => navigate(-1)}
    >
      Regresar
    </button>
        </div>
        
     
    </div>
  );
};

export default CompviewBlog;
